<template>
  <div id="contenedor-listado-licitacion-junta-aclaraciones-mobile">
    <template v-for="(participante, index) in licitacionParticipantes">
      <v-card :key="index" class="mb-3">
        <v-card-title>
          {{ participante.contratista.nombreRazonSocial }}
          <v-spacer></v-spacer>
          <v-card-text>Asistió a Junta de Aclaraciones?</v-card-text>
            <asistio-switch
            v-if="mixValidaScopesActions(2)"
            :participanteJuntaAclaraciones="participante"></asistio-switch>
        </v-card-title>
      </v-card>
    </template>
  </div>
</template>

<script>
import LICITACION_PARTICIPANTES from '@/graphql/querys/administracion/licitaciones/participantes/licitacionParticipantes.gql';
import AsistioSwitch from '@/components/administracion/licitaciones/juntaaclaraciones/Asistio.vue';

export default {
  name: 'ListadoLicitacionJuntaAclaracionesMobile',
  data() {
    return {};
  },
  components: {
    AsistioSwitch,
  },
  apollo: {
    licitacionParticipantes: {
      query: LICITACION_PARTICIPANTES,
      variables() {
        return {
          idLicitacion: this.$route.params.idLicitacion,
        };
      },
    },
  },
};
</script>

<style lang="scss">
</style>
